/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionField } from './InformationExtractionField';
import {
  InformationExtractionFieldFromJSON,
  InformationExtractionFieldFromJSONTyped,
  InformationExtractionFieldToJSON,
} from './InformationExtractionField';

/**
 *
 * @export
 * @interface InformationExtractionSchemaCreate
 */
export interface InformationExtractionSchemaCreate {
  /**
   *
   * @type {Array<InformationExtractionField>}
   * @memberof InformationExtractionSchemaCreate
   */
  fields: Array<InformationExtractionField>;
}

/**
 * Check if a given object implements the InformationExtractionSchemaCreate interface.
 */
export function instanceOfInformationExtractionSchemaCreate(value: object): value is InformationExtractionSchemaCreate {
  if (!('fields' in value) || value['fields'] === undefined) return false;
  return true;
}

export function InformationExtractionSchemaCreateFromJSON(json: any): InformationExtractionSchemaCreate {
  return InformationExtractionSchemaCreateFromJSONTyped(json, false);
}

export function InformationExtractionSchemaCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionSchemaCreate {
  if (json == null) {
    return json;
  }
  return {
    fields: (json['fields'] as Array<any>).map(InformationExtractionFieldFromJSON),
  };
}

export function InformationExtractionSchemaCreateToJSON(value?: InformationExtractionSchemaCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    fields: (value['fields'] as Array<any>).map(InformationExtractionFieldToJSON),
  };
}
